import { QueryResult, useQuery } from '@eika-infrastruktur/react-query';

import type { BirthdayInfo } from '../generated-types';
import { getBirthDayInfo } from '../services/profileService';

export const useBirthdayInfo = (): QueryResult<BirthdayInfo> =>
    useQuery({ queryKey: ['birthday-info'], queryFn: getBirthDayInfo });
